/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantPermissions } from './tenantPermissions';
import { AddressItemDto } from './addressItemDto';


export interface TenantItemDto { 
    id: string;
    name: string;
    email: string;
    type: TenantItemDto.TypeEnum;
    color: string;
    paymentAddress?: AddressItemDto;
    permissions: TenantPermissions;
    catalogSourceTenantId?: string;
    catalogSourceTenantName?: string;
    usesRiskAssessmentByDefault?: boolean;
}
export namespace TenantItemDto {
    export type TypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TypeEnum = {
        Internal: 'Internal' as TypeEnum,
        External: 'External' as TypeEnum,
        Contractor: 'Contractor' as TypeEnum
    };
}


